module.exports = __webpack_public_path__ + "media/images/client-hankook-b984eea976f8d544a2c5721214f774bd.png";